// src/api/client.js
import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000'

const api = axios.create({
  baseURL:        `${BASE_URL}/api`,
  withCredentials: true,          // required for Sanctum cookie auth
  headers: {
    'Accept':       'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
})

// ── CSRF cookie (Sanctum SPA auth) ───────────────────────────────────────────
export async function getCsrfCookie() {
  await axios.get(`${BASE_URL}/sanctum/csrf-cookie`, { withCredentials: true })
}

// ── Request interceptor: attach XSRF token ──────────────────────────────────
api.interceptors.request.use(config => {
  const token = document.cookie
    .split('; ')
    .find(r => r.startsWith('XSRF-TOKEN='))
    ?.split('=')[1]

  if (token) {
    config.headers['X-XSRF-TOKEN'] = decodeURIComponent(token)
  }
  return config
})

// ── Response interceptor: handle 401 / 403 / 422 ───────────────────────────
api.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status

    if (status === 401) {
      // Not authenticated — redirect to login (skip if already there or fetching user)
      const isAuthPage = ['/login', '/register', '/forgot-password'].some(p => window.location.pathname.startsWith(p))
      const isUserCheck = err.config?.url?.endsWith('/user')
      if (!isAuthPage && !isUserCheck) {
        window.location.href = '/login'
      }
    }

    if (status === 419) {
      // CSRF token mismatch — refresh and retry
      return getCsrfCookie().then(() => api.request(err.config))
    }

    return Promise.reject(err)
  }
)

export default api
